import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState } from 'react';
export var CommonsContext = createContext(undefined);
export var CommonsProvider = function (_a) {
    var children = _a.children;
    var _b = useState({}), variables = _b[0], setVariables = _b[1];
    var value = { variables: variables, setVariables: setVariables };
    return _jsx(CommonsContext.Provider, { value: value, children: children });
};
